module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'do-calendar__header': _vm.activeCalendarDate
    }
  }, [_c('div', {
    staticClass: "d-cal__header text-dark"
  }, [_c('div', {
    staticClass: "d-cal__header__left"
  }, [(_vm.userHasPermission('can_see_other_calendars')) ? _c('DCalendarSelect', {
    attrs: {
      "calendar": _vm.calendar
    }
  }) : _c('h2', [_vm._v(_vm._s(_vm.calendarName))]), _vm._v(" "), (_vm.activeCalendarDate) ? [_c('div', {
    staticClass: "do-button__multiple no-print"
  }, [_c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        placement: 'bottom',
        zIndex: 1212121212,
        onShow: function () { return _vm.hasHotKeys; }
      }),
      expression: "{\n               placement: 'bottom',\n               zIndex: 1212121212,\n               onShow: () => hasHotKeys\n             }"
    }],
    staticClass: "do-button__multiple__bttn icon-arrow-left4 no-print",
    attrs: {
      "content": _vm.tooltipArrowLeft
    },
    on: {
      "click": function($event) {
        return _vm.$emit('prev')
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "no-print do-button__multiple__bttn",
    class: {
      'bttn--disabled': _vm.isToday
    },
    on: {
      "click": function($event) {
        return _vm.$emit('today')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('repitition.today')) + "\n          ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        placement: 'bottom',
        zIndex: 1212121212,
        onShow: function () { return _vm.hasHotKeys; }
      }),
      expression: "{\n               placement: 'bottom',\n               zIndex: 1212121212,\n               onShow: () => hasHotKeys\n             }"
    }],
    staticClass: "do-button__multiple__bttn icon-arrow-right4 ",
    attrs: {
      "content": _vm.tooltipArrowRight
    },
    on: {
      "click": function($event) {
        return _vm.$emit('next')
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.dates) ? _c('h3', {
    staticClass: "do-calendar__date"
  }, [_vm._v(_vm._s(_vm.calendarDateInterval))]) : _vm._e(), _vm._v(" "), (_vm.isLoadingEvents) ? _c('div', {
    staticClass: "do-spinner"
  }) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "d-cal__header__right no-print"
  }, [(_vm.isMergeCalendar) ? _c('button', {
    class: {
      'do-bttn': _vm.activeCalendarDate
    },
    on: {
      "click": function($event) {
        return _vm.setIsShowMergeCalendars(true)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.editCalendarMenu.merge_with_calendar')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.userCanRequestAbsence) ? _c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        _vm.isShowAbsenceRequest = true
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.request_absence.request_absence')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.canEditPresence) ? _c('UserPresence', {
    attrs: {
      "calid": _vm.calendarId,
      "firstDayOfTheWeek": _vm.firstDayOfTheWeek,
      "activeCalendarDate": _vm.activeCalendarDate,
      "isModalLeft": true
    },
    on: {
      "saved": function($event) {
        return _vm.$emit('updateEvents')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeCalendarDate) ? _c('div', {
    staticClass: "do-calculate-hours"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        _vm.isShowCalculateHours = !_vm.isShowCalculateHours
      }
    }
  }, [_vm._v(_vm._s(_vm.i18n['calculate_hours']) + "\n          "), _c('span', {
    staticClass: "icon-arrow-down5"
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeInDown"
    }
  }, [(_vm.isShowCalculateHours) ? _c('div', {
    staticClass: "do-calculate-hours__dropdown"
  }, [_c('div', {
    staticClass: "do-calculate-hours__dropdown__header",
    on: {
      "click": function($event) {
        _vm.isShowCalculateHours = false
      }
    }
  }, [_c('div', {
    staticClass: "icon__bg-circle"
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('CalculateHours', {
    attrs: {
      "schoolId": _vm.schoolId,
      "calendarId": _vm.calendarId,
      "date": _vm.activeCalendarDate
    }
  })], 1) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('CopyCalendar', {
    attrs: {
      "calid": _vm.calendarId,
      "calendarType": _vm.calendarType,
      "activeCalendarDate": _vm.activeCalendarDate,
      "initCalendar": _vm.initCalendar
    },
    on: {
      "copyCalendarModalOpen": function($event) {
        return _vm.$emit('copyCalendarModalOpen', $event)
      }
    }
  }), _vm._v(" "), _c('Print', {
    attrs: {
      "calendarId": _vm.calendarId,
      "activeCalendarDate": _vm.activeCalendarDate
    }
  }), _vm._v(" "), (_vm.activeCalendarDate) ? _c('DCalendarHeaderDelete', {
    attrs: {
      "calendarId": _vm.calendarId,
      "firstDayOfTheWeek": _vm.firstDayOfTheWeek,
      "date": _vm.activeCalendarDate
    },
    on: {
      "update": function($event) {
        return _vm.$emit('updateCalendar')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('DDropdown', {
    attrs: {
      "isShowDots": false,
      "isBottomStart": false,
      "propOffset": [5, 5]
    }
  }, [_c('button', {
    class: {
      'do-bttn': _vm.activeCalendarDate
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('span', {
    staticClass: "icon-more2"
  })]), _vm._v(" "), _c('ul', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [(_vm.canBeLocked) ? _c('li', {
    on: {
      "click": _vm.toggleCalendarLock
    }
  }, [(_vm.isLocked) ? [_c('span', {
    staticClass: "icon-lock5"
  }), _vm._v(" " + _vm._s(_vm.$t('vue2.editCalendarMenu.unlock')) + "\n            ")] : [_vm._v("\n              " + _vm._s(_vm.$t('vue2.editCalendarMenu.lock')) + "\n            ")]], 2) : _vm._e(), _vm._v(" "), (_vm.canSeePublicCalendar) ? _c('li', {
    on: {
      "click": _vm.openPublicCalendar
    }
  }, [(_vm.isAnonymousAccessActivated) ? [_vm._v("\n              " + _vm._s(_vm.$t('vue2.editCalendarMenu.see_public_view')) + "\n            ")] : [_vm._v("\n              " + _vm._s(_vm.$t('vue2.editCalendarMenu.active_public_view')) + "\n            ")]], 2) : _vm._e(), _vm._v(" "), (_vm.canSeeMergeWithMergeCalendars) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.setIsShowMergeCalendars(true)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.editCalendarMenu.merge_with_merge_calendars')) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.canSeeExportCalendar) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.setIsShowExportCalendarModal(true)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.calendar_export.export_calendar')) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.canToggleViewState) ? _c('li', [_c('span', {
    staticClass: "icon-arrow-left4"
  }), _vm._v(" " + _vm._s(_vm.$t('vue2.editCalendarMenu.view')) + "\n            "), _c('ul', [_c('li', {
    on: {
      "click": function($event) {
        return _vm.toggleCalendarView(0)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.editCalendarMenu.5_days')))]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.toggleCalendarView(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.editCalendarMenu.7_days')))]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.toggleCalendarView(2)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.editCalendarMenu.7_days_and_24_hours')))])])]) : _vm._e(), _vm._v(" "), (_vm.canEditName) ? _c('li', {
    on: {
      "click": _vm.openEditNameModal
    }
  }, [_c('span', {
    staticClass: "icon-pencil"
  }), _vm._v("\n            " + _vm._s(_vm.$t('vue2.editCalendarMenu.edit_name')) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.canBeDeleted) ? _c('li', {
    staticClass: "d-item-warning",
    on: {
      "click": _vm.openDeleteModal
    }
  }, [_c('span', {
    staticClass: "icon-bin"
  }), _vm._v("\n            " + _vm._s(_vm.$t('vue2.editCalendarMenu.delete_calendar')) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.canBeArchived) ? _c('li', {
    staticClass: "d-item-warning",
    on: {
      "click": _vm.archiveCalendar
    }
  }, [_c('span', {
    staticClass: "icon-bin"
  }), _vm._v(" " + _vm._s(_vm.$t('vue2.editCalendarMenu.remove_calendar')) + "\n          ")]) : _vm._e()])]), _vm._v(" "), (_vm.isLocked) ? _c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        placement: 'left'
      }),
      expression: "{arrow: true,placement : 'left'}"
    }],
    attrs: {
      "content": _vm.$t('vue2.editCalendarMenu.calendar_is_locked')
    }
  }, [(true) ? _c('div', {
    staticClass: "d-cal__header__right__lock icon__bg-circle",
    on: {
      "click": _vm.toggleCalendarLock
    }
  }, [_c('span', {
    staticClass: "icon-lock5"
  })]) : _c('div', {
    staticClass: "d-cal__header__right__lock"
  }, [_c('span', {
    staticClass: "icon-lock5"
  })])]) : _vm._e()], 1)]), _vm._v(" "), (_vm.calendar) ? _c('EditCalendarEditName', {
    attrs: {
      "calendar": _vm.calendar
    }
  }) : _vm._e(), _vm._v(" "), (_vm.calendar) ? _c('EditCalendarDelete', {
    attrs: {
      "calendar": _vm.calendar
    }
  }) : _vm._e(), _vm._v(" "), _c('ExportCalendar', {
    attrs: {
      "isShowButton": false,
      "isShowFromProp": _vm.isShowExportCalendarModal,
      "calLink": _vm.iCalUrl
    },
    on: {
      "close": function($event) {
        return _vm.setIsShowExportCalendarModal(false)
      }
    }
  }), _vm._v(" "), (_vm.isShowMergeCalendars) ? _c('CalendarMergeModal', {
    attrs: {
      "schoolId": _vm.schoolId,
      "calendarId": _vm.calendarId,
      "calendar": _vm.calendar
    },
    on: {
      "close": function($event) {
        return _vm.setIsShowMergeCalendars(false)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowCalculateHours) ? _c('div', {
    staticClass: "bg-overlay do-datepicker__dropdown__overlay",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.isShowCalculateHours = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowAbsenceRequest) ? _c('UserRequest', {
    on: {
      "close": function($event) {
        _vm.isShowAbsenceRequest = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-246c188a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DCalendar/DCalendarHeader.vue
// module id = 1546
// module chunks = 1